<script setup lang="ts">
import { inject } from 'vue'
import { useI18n } from 'vue-i18n'

import { ProjektFinancovanieSposobFinancovaniaEnum } from '/@src/client-portal'

const { t } = useI18n()
const isReadOnly = inject<boolean>('isReadOnly')
</script>

<template>
  <div>
    <!-- Toto v RW mode ma byt skryte -->
    <ValidationWrapper
      v-slot="slotProps"
      :key="isReadOnly && Math.random()"
      name="projekt.financovanie.sposobFinancovania"
      :value="[]"
    >
      <IDSKCheckboxes
        v-bind="slotProps"
        id="zoppm-step11-part1-defaultValue"
        :label="t('zoppm.step11.part1.radioLabel')"
        :options="[
          {
            value: ProjektFinancovanieSposobFinancovaniaEnum['SystemPredfinancovania'],
            label: t('zoppm.step11.part1.radioOpt1'),
            id: 'zoppm-step11-part1-defaultValue#SystemPredfinancovania',
          },
          {
            value: ProjektFinancovanieSposobFinancovaniaEnum['SystemZalohovyvhPlatieb'],
            label: t('zoppm.step11.part1.radioOpt2'),
            id: 'zoppm-step11-part1-defaultValue#SystemZalohovyvhPlatieb',
          },
          {
            value: ProjektFinancovanieSposobFinancovaniaEnum['SystemRefundacie'],
            label: t('zoppm.step11.part1.radioOpt3'),
            id: 'zoppm-step11-part1-defaultValue#SystemRefundacie',
          },
        ]"
      >
      </IDSKCheckboxes>
    </ValidationWrapper>
  </div>
</template>
